// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts';
export let DirectBrandingRulesMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_BRANDING_MESSAGE)

    this.Tools = null;
    this.CompanyName = null;
    this.BrokerInformation = null;
    this.PoweredByName = null;
    this.PoweredByURL = null;
    this.BrandingClientSessionTimeoutInMinutes = -1;
    this.BrandingDemoregistrationURL = "";
    this.BrandingForgotpwdURL = "";
    this.BrandingIpServicesURL = "";
    this.BrandingWebName = "";
    this.BrandingWebLoginBanner = "";
    this.BrandingWebSplashScreen = "";
    this.BrandingWebHeader = "";
    this.BrandingWebFavicon = "";
    this.BrandingWMLoginBanner = "";
    this.BrandingWMBackgroundImage = "";
    this.BrandingWMFavicon = "";
    this.BrandingInvestingCustomScheme = "";
    this.BrandingInvestingFavicon = "";
    this.BrandingInvestingSplashScreen = "";
    this.BrandingInvestingLoginBanner = "";
    this.BrandingInvestingWebHeader = "";
    this.BrandingWebLangFiles = "";
}

DirectBrandingRulesMessage.prototype = Object.create(DirectMessageBase.prototype)